import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Note } from 'lib-trend-core';
@Component({
    selector: 'app-edit-note-attendance',
    // templateUrl: './edit-note-attendance.component.html',
    templateUrl: './edit-note-attendance.v2.component.html',
    styleUrls: ['edit-note-attendance.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditNoteAttendanceComponent {

  formGroup: FormGroup; 

  constructor(
    public dialogRef: MatDialogRef<EditNoteAttendanceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { note: Note },
    private formBuilder: FormBuilder
  ) {
    this.createForm();
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      description: [this.data.note.description, Validators.required], 
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false); 
  }

  onConfirmClick(): void {
    if (this.formGroup.valid) {
      const editedNote: Note = {
        ...this.data.note,
        description: this.formGroup.value.description, 
      };
      this.dialogRef.close(editedNote); 
    }
  }

  close(value?: any): void {
    this.dialogRef.close();
  }

}
